var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { BaseService } from "app/views/base.service";
import { getUrlParams } from "app/lib/lib";
var SiteSubCategoriesService = /** @class */ (function (_super) {
    __extends(SiteSubCategoriesService, _super);
    function SiteSubCategoriesService(http) {
        return _super.call(this, http) || this;
    }
    SiteSubCategoriesService.prototype.getStats = function (queryParams) {
        var params = getUrlParams(queryParams);
        return this.q$.push(this.http.get("/site_sub_categories/stats?" + params)).pipe(map(function (r) { return r[1]; }));
    };
    return SiteSubCategoriesService;
}(BaseService));
export { SiteSubCategoriesService };
